import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { StorageMap } from '@ngx-pwa/local-storage';
import { LoginAuthWithLanguage } from '@sk/sk-interfaces';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class LanguageGuard implements CanActivate {

  constructor(private storage: StorageMap,
              private snackbar : MatSnackBar,
              @Inject(DOCUMENT) private document: Document) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {

    // check for User

    return this.storage.get('auth')
      .pipe(
        take(1),
        map((auth: LoginAuthWithLanguage) => {
          console.log('Hello from Language guard');
          // No user saved in indexDB
          if (!auth) {
            console.log('No Auth');
            return true;
          }
          if (auth && auth.language) {
            console.log('Auth');
            const language = auth.language;
            const urlOrigin = this.document.location.origin;
            const url = this.document.location.href;
            if (url.includes('localhost')) {
              console.log('DEV Mode');
              return true;
            }
            switch (language) {
              case 'nl-NL':
                if (url.includes('/nl')) {
                  return true;
                }
                this.document.location.replace(`${urlOrigin}/nl/`);
                this.snackbar.open('Nederlands laden...', '')
                break;
              case 'en-US':
                if (url.includes('/en')) {
                  return true;
                }
                this.snackbar.open('Loading English...', '')
                this.document.location.replace(`${urlOrigin}/en/`);
                break;
              case 'es-US':
                if (url.includes('/es')) {
                  return true;
                }
                this.document.location.replace(`${urlOrigin}/es/`);
                this.snackbar.open('Cargando idioma español...', '')
                break;
            }
          }
          console.log('No hit return false');
          return false;
        })
      );
  }

}
